var render, staticRenderFns
import script from "./FormProductStandard.vue?vue&type=script&lang=js"
export * from "./FormProductStandard.vue?vue&type=script&lang=js"
import style0 from "./FormProductStandard.vue?vue&type=style&index=0&id=2198ddf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198ddf8",
  null
  
)

export default component.exports